import { FilePdfFilled, HomeOutlined } from "@ant-design/icons";
import { Breadcrumb as BC } from "antd";
import { Link } from "react-router-dom";
import { Folder } from "../../redux/interfaces/folder.types.ts";

interface Props {
  folder: Folder;
}

export const BreadcrumbComponent: React.FC<Props> = ({ folder }) => {
  const tenant = folder.metadata?.tenant;

  return (
    <BC
      items={[
        {
          title: (
            <Link to="/">
              <HomeOutlined />
            </Link>
          ),
        },
        {
          title: (
            <Link to="/folders">
              <FilePdfFilled />
              <span>Expedientes</span>
            </Link>
          ),
        },
        {
          title: `${tenant?.full_name || ""}`,
        },
      ]}
    />
  );
};
